module.exports = __webpack_public_path__ + "img/table-delete.7713cd5f.svg";